import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { DialogRef } from '@angular/cdk/dialog'
import { DialogBaseComponent } from '@navix/ui/common'

@Component({
  selector: 'navix-access-tenant-dialog',
  standalone: true,
  imports: [DialogBaseComponent],
  templateUrl: './access-tenant-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessTenantDialogComponent {
  private readonly dialogRef = inject(DialogRef)

  closeDialog() {
    this.dialogRef.close()
  }

  async redirectToList() {
    this.dialogRef.close()
  }
}
